import styled from "styled-components"
import { GLOBAL_STYLES } from "./styles/GLOBAL_STYLE"
import { type IStyle } from "./interfaces/IStyle"

export const Container = styled.div<IStyle>`
  background-color: ${({ themeContext }) => GLOBAL_STYLES.HEADER.MENU.BACKGROUND_2[themeContext ?? ""]};
  font-family: ${GLOBAL_STYLES.FONT.FAMILY};
`
